import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { PollData } from '../../../../providers/poll';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { IClientConfig } from '../../../../models/client.model';
import { IUser } from '../../../../models/user.model';
import * as clientSelectors from '../../../../ngrx/reducers/client.reducer';
import * as userSelectors from '../../../../ngrx/reducers/auth.reducer';
import { PageTrack } from '../../../../shared/decorators/analytics';
import uniqid from 'uniqid';

const uidTrack = uniqid();
const pageName = 'PollActiveComponent';

@Component({
  selector: 'app-poll-active',
  templateUrl: 'poll-active.html',
})
@PageTrack(uidTrack, pageName)
export class PollActiveComponent implements OnInit, OnDestroy {

  public clientId: string;
  public pollId: string;
  public activePoll$: Observable<any>;
  public clientConfig$: Observable<IClientConfig>;
  public userInformationSubs: Subscription;
  public userInformation: IUser;
  public showQuestions: boolean = false;

  constructor(
    private pollData: PollData,
    private navParams: NavParams,
    private store: Store<{}>,
    private viewCtrl: ViewController
  ) { }

  ngOnInit() {
    this.clientId = this.navParams.get('clientId');
    this.pollId = this.navParams.get('pollId');
    this.getUserInformation();
    this.getPollActive();
    this.getClientConfig();
  }

  /**
   * Get User Information
   * @author Sebastián Guevara
   */
  private getUserInformation() {
    this.userInformationSubs = this.store.select(userSelectors.getUser)
      .subscribe((userInformation) => {
        this.userInformation = userInformation;
      })
  }

  /**
   * Get Client Configuration
   * @author Sebastián Guevara
  */
  private getClientConfig() {
    this.clientConfig$ = this.store.select(clientSelectors.getClientConfig);
  }

  /**
   * Get Poll Active
   * Based on clientId and PollId
   * @author Sebastián Guevara
   */
  private getPollActive() {
    this.activePoll$ = this.pollData.getPollByClientId(this.clientId, this.pollId);
  }

  /**
   * Set showQuestions variable to show or not the questions
   * @param show
   * @author Sebastián Guevara
   */
  public setShowQuestions(show: boolean) {
    this.showQuestions = show;
  }

  /**
   * Close Modal
   * @author Sebastián Guevara
  */
  public closeModal() {
    this.viewCtrl.dismiss();
  }

  ngOnDestroy() {
    if (this.userInformationSubs) this.userInformationSubs.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/pages/poll/components/poll-active/poll-active.ts